import React from 'react';
import { TabPanel as HeadlessTabPanel } from '@headlessui/react';
import { cn } from '../../utils/cn';

export const TabPanel = React.forwardRef<
  React.ElementRef<typeof HeadlessTabPanel>,
  React.ComponentPropsWithoutRef<typeof HeadlessTabPanel> & {
    className?: string;
  }
>(({ children, className, ...props }, ref) => (
  <HeadlessTabPanel
    ref={ref}
    className={cn(
      // Base layout
      'relative',

      // Rounded borders except top left
      'rounded-tl-none rounded-tr-2xl rounded-b-2xl',

      // Background and edge
      'border-container-border border bg-white dark:bg-gray-800',

      // Padding
      'p-5',

      className,
    )}
    {...props}
  >
    {children}
  </HeadlessTabPanel>
));

TabPanel.displayName = 'TabPanel'; // Changed from 'Tab' to 'TabPanel'
